import { ClipboardModule } from '@angular/cdk/clipboard';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InventoryModule } from 'src/app/external-user/inventory/inventory.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomerManagementModule } from '../customer-management/customer-management.module';
import { CertManagerDialogComponent } from './components/cert-manager-dialog/cert-manager-dialog.component';
import { DeploymentFormDialogComponent } from './components/deployment-form-dialog/deployment-form-dialog.component';
import { DynamicDeploymentControlComponent } from './components/dynamic-deployment-control/dynamic-deployment-control.component';
import { EdgeApplianceDetailsComponent } from './components/edge-appliance-details/edge-appliance-details.component';
import { EdgeDeviceSelectComponent } from './components/edge-device-select/edge-device-select.component';
import { FleetManagementComponent } from './components/fleet-management.component';
import { OnboardVmDialogComponent } from './components/onboard-vm-dialog/onboard-vm-dialog';
import { OrganizationSelectComponent } from './components/organization-select/organization-select.component';
import { PreProvisionedComponent } from './components/pre-provisioned/pre-provisioned.component';
import { ProvisionedComponent } from './components/provisioned/provisioned.component';
import { SiteSelectComponent } from './components/site-select/site-select.component';
import { SystemFormComponent } from './components/system-form/system-form.component';
import { SystemSelectComponent } from './components/system-select/system-select.component';
import { FleetManagementRoutingModule } from './fleet-management-routing.module';

@NgModule({
  declarations: [
    FleetManagementComponent,
    PreProvisionedComponent,
    ProvisionedComponent,
    EdgeApplianceDetailsComponent,
    DeploymentFormDialogComponent,
    OrganizationSelectComponent,
    SiteSelectComponent,
    SystemSelectComponent,
    EdgeDeviceSelectComponent,
    SystemFormComponent,
    DynamicDeploymentControlComponent,
    OnboardVmDialogComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    ScrollingModule,
    CdkTableModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatProgressSpinnerModule,
    FleetManagementRoutingModule,
    CustomerManagementModule,
    InventoryModule,
    ClipboardModule,
    CertManagerDialogComponent
  ]
})
export class FleetManagementModule { }
